<template lang="pug">
    section
        v-container(fluid).pa-0
            v-expansion-panels(light tile)
                v-expansion-panel
                    v-expansion-panel-header Фильтры и поиск
                        div.ml-5
                            v-btn(rounded small @click.stop="filters_clear") Очистить
                    v-expansion-panel-content
                        v-row(no-gutters)
                            v-col(cols="12" md="6")
                                v-row()
                                    v-col(cols="12" sm="6").py-0
                                        v-subheader Покупка
                                        v-row
                                            v-col(cols="12").py-0
                                                v-menu(v-model='datepicker_menu_from' :close-on-content-click='false' :nudge-right='40' transition='scale-transition' offset-y min-width='290px')
                                                    template(v-slot:activator='{ on, attrs }')
                                                        v-text-field(v-model='dateFromFormatted' label='Начало периода' prepend-icon='mdi-calendar' readonly v-bind="attrs" v-on="on")
                                                    v-date-picker(v-model='table_filters.dates.from'  @input="datepicker_menu_from = false")
                                            v-col(cols="12").py-0
                                                v-menu(v-model='datepicker_menu_to' :close-on-content-click='false' :nudge-right='40' transition='scale-transition' offset-y min-width='290px')
                                                    template(v-slot:activator='{ on, attrs }')
                                                        v-text-field(v-model='dateToFormatted' label='Конец периода' hide-details prepend-icon='mdi-calendar' readonly v-bind="attrs" v-on="on")
                                                    v-date-picker(v-model='table_filters.dates.to' @input="datepicker_menu_to = false" locale="ru-RU")
                                    v-col(cols="12" sm="6").py-0
                                        v-subheader Продажа
                                        v-row
                                            v-col(cols="12").py-0
                                                v-menu(v-model='datepicker_menu_from_sell' :close-on-content-click='false' :nudge-right='40' transition='scale-transition' offset-y min-width='290px')
                                                    template(v-slot:activator='{ on, attrs }')
                                                        v-text-field(v-model='dateFromSellFormatted' label='Начало периода' prepend-icon='mdi-calendar' readonly v-bind="attrs" v-on="on")
                                                    v-date-picker(v-model='table_filters.dates.from_sell'  @input="datepicker_menu_from_sell = false")
                                            v-col(cols="12").py-0
                                                v-menu(v-model='datepicker_menu_to_sell' :close-on-content-click='false' :nudge-right='40' transition='scale-transition' offset-y min-width='290px')
                                                    template(v-slot:activator='{ on, attrs }')
                                                        v-text-field(v-model='dateToSellFormatted' label='Конец периода' hide-details prepend-icon='mdi-calendar' readonly v-bind="attrs" v-on="on")
                                                    v-date-picker(v-model='table_filters.dates.to_sell' @input="datepicker_menu_to_sell = false" locale="ru-RU")
                            v-spacer
                            v-col.pt-3(align-self="end")
                                v-text-field(
                                    v-model="table_filters.search"
                                    append-icon="mdi-magnify"
                                    label="Поиск по сделкам"
                                    single-line
                                    hide-details
                                )
        v-data-table.elevation-0.mt-1(
            :header-props="headerProps"
            :headers='tableHeaders'
            :search="table_filters.search"
            :single-expand="singleExpand"
            fixed-header
            height="75vh"
            item-key="id"
            :expanded.sync="expanded"
            disable-pagination
            hide-default-footer
            :items='deals'
        )
            template(v-slot:item.date_buy="{ item }") {{ item.date_buy | formatDateToLocale }}
            template(v-slot:item.date_sell="{ item }") {{ item.date_sell | formatDateToLocale }}
            template(v-slot:item.symbol.full_name="{ item }")
                b {{ item.symbol.full_name }}
            template(v-slot:item.buy_cost="{ item }") {{ item.buy_cost | toUSD }}
            template(v-slot:item.commission.buy="{ item }") {{ item.commission.buy | toUSD }}
            template(v-slot:item.get_deal_cost_info.deal_cost_buy="{ item }") {{ item.get_deal_cost_info.deal_cost_buy | toUSD }}
            template(v-slot:item.get_deal_cost_info.income="{ item }")
                div.income
                    div.positive(v-if="item.get_deal_cost_info.income > 0")
                        v-icon(color="success" dark) mdi-arrow-up-bold
                    div.negative(v-else)
                        v-icon(color="error" dark) mdi-arrow-down-bold
                    div.income__text
                        div.font-weight-bold(
                            :class="{'success--text': item.get_deal_cost_info.income > 0, 'error--text': item.get_deal_cost_info.income < 0}"
                            ) {{ item.get_deal_cost_info.income | toUSD }}
                        a.grey--text.text-decoration-underline(@click="expandRow(item)" color="primary" x-small) Подробнее
            template(v-slot:expanded-item='{ headers, item }')
                td(:colspan='tableHeaders.length').pa-0.ma-0
                    v-sheet(dark).pa-2.test
                        v-container(fluid)
                            div.text-h5.mb-3.text-center {{ item.symbol.full_name }}
                            v-row
                                v-col(cols="12" sm="6" md="6"  xs="12")
                                    v-card(flat light)
                                        v-card-title Покупка
                                        v-card-subtitle {{ item.symbol.symbol }}
                                        v-card-title.body-1
                                            .expanded-list-wrap(v-show="true")
                                                ul.expanded-list
                                                    li.expanded-list__item
                                                        div.expanded-list__item__title Дата
                                                        div.expanded-list__item__value {{ item.date_buy | formatDateToLocale }}
                                                    li.expanded-list__item
                                                        div.expanded-list__item__title Цена акции
                                                        div.expanded-list__item__value {{ item.buy_cost | toUSD }}
                                                    li.expanded-list__item
                                                        div.expanded-list__item__title Комиссия
                                                        div.expanded-list__item__value {{ item.commission.buy | toUSD }}
                                                    li.expanded-list__item
                                                        div.expanded-list__item__title Сумма
                                                        div.expanded-list__item__value {{ item.get_deal_cost_info.deal_cost_buy | toUSD }}
                                v-col(cols="12" xs="12" sm="6" md="6")
                                    v-card(flat light)
                                        v-card-title Продажа
                                        v-card-subtitle {{ item.symbol.symbol }}
                                        v-card-title.body-1
                                            .expanded-list-wrap(v-show="true")
                                                ul.expanded-list
                                                    li.expanded-list__item
                                                        div.expanded-list__item__title Дата
                                                        div.expanded-list__item__value {{ item.date_sell | formatDateToLocale }}
                                                    li.expanded-list__item
                                                        div.expanded-list__item__title Цена акции
                                                        div.expanded-list__item__value {{ item.cost | toUSD }}
                                                    li.expanded-list__item
                                                        div.expanded-list__item__title Комиссия
                                                        div.expanded-list__item__value {{ item.commission.sell | toUSD }}
                                                    li.expanded-list__item
                                                        div.expanded-list__item__title Сумма
                                                        div.expanded-list__item__value {{ item.get_deal_cost_info.deal_cost_sell | toUSD }}
                                                    li.expanded-list__item
                                                        div.expanded-list__item__title Доход
                                                        div.expanded-list__item__value.positive(v-if="item.get_deal_cost_info.income > 0")
                                                            div {{ item.get_deal_cost_info.income | toUSD }}
                                                            v-icon() mdi-arrow-up-bold
                                                        div.expanded-list__item__value.negative(v-else)
                                                            div {{ item.get_deal_cost_info.income | toUSD }}
                                                            v-icon() mdi-arrow-down-bold
                        v-data-table(
                            v-show="false"
                            :items="expanded"
                            :headers="expandTableHeaders"
                            disable-pagination
                            hide-default-footer
                        )
                            template(v-slot:item.date_sell="{ item }") {{ item.date_sell | formatDateToLocale }}
                            template(v-slot:item.cost="{ item }") {{ item.cost | toUSD }}
                            template(v-slot:item.commission.sell="{ item }") {{ item.commission.sell | toUSD }}
                            template(v-slot:item.get_deal_cost_info.deal_cost_sell="{ item }") {{ item.get_deal_cost_info.deal_cost_sell | toUSD }}

</template>

<script>
    export default {
        name: "PortfolioHistoryClosed",
        props: {
            deals: Array
        },
        computed: {
            dateFromFormatted () {
                return this.table_filters.dates.from ? this.$options.filters.formatDateToLocale(this.table_filters.dates.from) : null
            },
            dateToFormatted () {
                return this.table_filters.dates.to ? this.$options.filters.formatDateToLocale(this.table_filters.dates.to) : null
            },
            dateFromSellFormatted () {
                return this.table_filters.dates.from_sell ? this.$options.filters.formatDateToLocale(this.table_filters.dates.from_sell) : null
            },
            dateToSellFormatted () {
                return this.table_filters.dates.to_sell ? this.$options.filters.formatDateToLocale(this.table_filters.dates.to_sell) : null
            },
        },
        data () {
            return {
                table_filters: {
                    dates:{
                        from: null,
                        to: null,
                        from_sell: null,
                        to_sell: null,
                    },
                    search:''
                },
                datepicker_menu_from: null,
                datepicker_menu_to: null,
                datepicker_menu_from_sell: null,
                datepicker_menu_to_sell: null,
                expanded: [],
                singleExpand: false,
                headerProps: {
                    sortByText: "Упорядочить по"
                },
                tableHeaders: [
                    {
                        text: 'Покупка',
                        align: 'start',
                        sortable: true,
                        value: 'date_buy',
                        fixed: true,
                        width: '1%',
                        filter: value => {
                            if (!((this.table_filters.dates.from) && (this.table_filters.dates.to))) return true
                            let date_from = new Date(Date.parse(this.table_filters.dates.from))
                            let date_to = new Date(Date.parse(this.table_filters.dates.to))
                            let date_item = new Date(Date.parse(value))
                            return (date_from < date_item) && (date_item < date_to)
                        }
                    },
                    {
                        text: 'Продажа',
                        align: 'start',
                        sortable: true,
                        value: 'date_sell',
                        fixed: true,
                        width: '1%',
                        filter: value => {
                            if (!((this.table_filters.dates.from_sell) && (this.table_filters.dates.to_sell))) return true
                            let date_from = new Date(Date.parse(this.table_filters.dates.from_sell))
                            let date_to = new Date(Date.parse(this.table_filters.dates.to_sell))
                            let date_item = new Date(Date.parse(value))
                            return (date_from < date_item) && (date_item < date_to)
                        }
                    },
                    {
                        text: 'Название',
                        sortable: true,
                        value: 'symbol.full_name',
                        width: '1%'
                    },
                    { text: 'Тикер', value: 'symbol.short', width: '1%'},
                    { text: 'Кол-во', value: 'count', width: '1%' },
                    { text: 'Доход', value: 'get_deal_cost_info.income', width: '1%'},
                    // { text: '', value: 'sell_info', align: 'center', sortable: false, width: '1%'},
                ],
                expandTableHeaders: [
                    {
                        text: 'Дата продажи',
                        align: 'start',
                        sortable: true,
                        value: 'date_buy',
                        fixed: true,
                        width: '140px',
                    },
                    { text: 'Цена акции', value: 'buy_cost' },
                    { text: 'Количество', value: 'count' },
                    { text: 'Общая комиссия', value: 'commission.sell'},
                    { text: 'Сумма с комис. клиента', value: 'get_deal_cost_info.deal_cost_sell'},
                ],
            }
        },
        methods: {
            expandRow (item) {
                this.expanded = item === this.expanded[0] ? [] : [item]
            },
            filters_clear () {
                for (let item in this.table_filters.dates) {
                    this.table_filters.dates[item] = null
                }
                this.table_filters.search = ''
            }
        }
    }
</script>

<style scoped lang="scss">
    .test{
        background: url('~@/assets/bg_sell2.jpg') no-repeat center;
        -webkit-background-size: cover;
        background-size: cover;
    }
    .income{
        display: flex;
        align-items: center;
        &__text{
            margin-left: 6px;
        }

    }
    .expanded-list{
        list-style-type: none;
        padding-left: 0;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
        grid-gap: 20px 10px;
        /*flex-direction: column;*/
        /*justify-content: space-between;*/
        &-wrap{
            width: 100%;
        }
        &__item{
            /*border-right: 1px solid #ddd;*/
            /*padding: 10px 15px;*/
            /*margin: 5px;*/
            /*background: #333;*/
            &:last-child{
                border-right: none;
            }
            &__title{
                font-size: .8rem;
                /*text-transform: uppercase;*/
                color: #888;
            }
            &__value{
                font-size: 1.1em;
                display: flex;
                align-items: center;
                font-weight: 400;
                &.positive{
                    i{
                        color: green !important;
                    }
                }
            }
        }

    }
</style>
